import { render, staticRenderFns } from "./MiniAddButtonWithHelp.vue?vue&type=template&id=70045869"
import script from "./MiniAddButtonWithHelp.vue?vue&type=script&lang=js"
export * from "./MiniAddButtonWithHelp.vue?vue&type=script&lang=js"
import style0 from "./MiniAddButtonWithHelp.vue?vue&type=style&index=0&id=70045869&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports